import { Box, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { CollapseList } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React, { useMemo } from 'react';
import { scrollerNodeRefAtom } from '../../atoms/session-atoms';
import { BiCtaNames } from '../../bi/types';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { SpecificPageList } from '../wizard-content/content-results/card-groups/lists/specific-page-list';
import { SpecificPageTaskList } from '../wizard-content/content-results/card-groups/lists/specific-page-task-list';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
export const VerticalsDrillInContentCards = () => {
  const {
    t
  } = useTranslation();
  const {
    itemType,
    pageId = '',
    crossPagesRuleResult,
    specificRuleGroupPaginationObject,
    shouldShowMaxPagesWarning,
    screenTitle,
    limitedRuleGroups,
    isAllCrossPageIssuePassed
  } = useVerticalDrillInScreen();
  const biLogger = useBiLogger();
  const totalPages = limitedRuleGroups.length ?? 0;
  const {
    ruleGroupToShow,
    isPaginationEnabled,
    setIsPaginationEnabled,
    getPaginationComponent,
    isPagination
  } = specificRuleGroupPaginationObject;
  const scrollerNode = useAtomValue(scrollerNodeRefAtom);
  const pageIds = useMemo(() => {
    return ruleGroupToShow.map(ruleGroup => ruleGroup.groupId);
  }, [ruleGroupToShow]);
  const ruleResultsMap = useMemo(() => {
    const map = new Map();
    ruleGroupToShow.forEach(ruleGroup => {
      const isLoading = ruleGroup.isLoading ?? false;
      map.set(ruleGroup.groupId, {
        isLoading,
        ruleResults: ruleGroup.ruleResults
      });
    });
    return map;
  }, [ruleGroupToShow]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP2 SP4 SP6 SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "D60",
    borderRadius: "8px",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "SP4"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "accessibility-wizard.verticals-drill-in.content-section.header.total-pages",
    values: {
      screenTitle,
      totalPages
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(CollapseList, {
    autoScroll: true,
    contentGap: 0,
    dividerPadding: "0",
    scrollContainerRef: scrollerNode ?? undefined
  }, /*#__PURE__*/React.createElement(CollapseList.SectionItem, {
    backgroundColor: "D70",
    id: "cross-pages",
    key: "cross-pages",
    title: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.divider`),
    tooltipSize: "small",
    tooltipText: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.tooltip.${itemType}`)
  }), /*#__PURE__*/React.createElement(SpecificPageTaskList, {
    key: "cross-pages-tasks",
    pageId: pageId,
    ruleResults: crossPagesRuleResult
  }), /*#__PURE__*/React.createElement(CollapseList.SectionItem, {
    backgroundColor: "D70",
    id: "page-specific",
    title: t('accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.divider'),
    tooltipSize: "small",
    tooltipText: t(`accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.tooltip.${itemType}`)
  }), /*#__PURE__*/React.createElement(SpecificPageList, {
    isAllCrossPageIssuePassed: isAllCrossPageIssuePassed,
    key: "specific-page-list",
    pageIds: pageIds,
    ruleResultsMap: ruleResultsMap
  }), isPagination && isPaginationEnabled && !shouldShowMaxPagesWarning && getPaginationComponent(), !isPaginationEnabled && /*#__PURE__*/React.createElement(Box, {
    margin: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: () => {
          biLogger.ctaClick({
            ctaName: BiCtaNames.ShowAllPages
          });
          setIsPaginationEnabled(true);
        }
      })
    },
    i18nKey: `accessibility-wizard.verticals-drill-in.content-section.pagination.enable-pagination.${itemType}`
  })))))));
};
//# sourceMappingURL=verticals-drill-in-content-cards.js.map